import { ComponentIds, Entity } from '@inter-ikea-core/core';
import ProductInfoComponent from '../components/ProductInfoComponent';
import { NonMarketProduct, Product } from '../..';

export const isOfType = (typeCodes: string[]) => {
  return (entity: Entity) => {
    if (!entity) return false;
    const productType = entity.getComponent<ProductInfoComponent>(ProductInfoComponent.id)
      ?.productType;
    if (!productType) return false;
    return typeCodes.includes(productType);
  };
};

export const getProduct = (
  entity: Entity,
  products: (Product | NonMarketProduct)[]
): Product | null => {
  const product = products.find(p => p.coreProductId === getProductReferenceFor(entity));
  if (product) {
    return product as Product;
  }
  return null;
};

export const isProduced = (entity: any) => {
  if (!entity) return false;
  return entity.hasComponent(ComponentIds.PRODUCT_COMPONENT_ID);
};

export const getProductReferenceFor = (entity: any) => {
  if (!entity.isDisposed) return entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)?.productRef;
};

export const isAssembly = (entity: any) => {
  if (!entity) return false;
  return entity.hasComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID);
};

export const isProductPart = (entity: Entity): boolean => {
  return entity.hasComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID);
};

export const isUnavailableProduct = (entity: Entity, unavailableProducts: Product[]): boolean => {
  const unavailableProductIds = unavailableProducts.map(p => p.coreProductId);
  const productRef = getProductReferenceFor(entity);
  return unavailableProductIds.includes(productRef);
};
